/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const handleLogout = () => {
    // Clear all data from localStorage
    localStorage.clear();
    // Or if you want to clear specific items:
    // localStorage.removeItem('isAuthenticated');
    // localStorage.removeItem('token');

    // Redirect to login page
    navigate("/login");
  };

  return (
    <div className="sticky top-0 z-20">
      <div className="navbar h-16 bg-[#F9FAFB] shadow-sm px-4">
        <div className="flex-1 gap-2">
          <label
            htmlFor="my-drawer"
            className="btn btn-ghost btn-circle lg:hidden"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="inline-block w-5 h-5 stroke-current"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </label>
          <div className="form-control flex-1 max-w-xl">
            {/* <div className="relative w-full">
              <input 
                type="text" 
                placeholder={t('header.search')}
                className="input input-bordered w-full pl-10" 
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
              </div>
            </div> */}
          </div>
        </div>

        <div className="flex-none gap-4">
          <div className="flex gap-2">
            <button
              className={`btn btn-sm ${
                i18n.language === "en" ? "btn-primary" : "btn-ghost"
              }`}
              onClick={() => changeLanguage("en")}
            >
              EN
            </button>
            <button
              className={`btn btn-sm ${
                i18n.language === "vi" ? "btn-primary" : "btn-ghost"
              }`}
              onClick={() => changeLanguage("vi")}
            >
              VI
            </button>
          </div>
          <div className="dropdown dropdown-end">
            <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
              <div className="w-10 rounded-full">
                <img
                  src="https://api.dicebear.com/7.x/avataaars/svg?seed=admin"
                  alt="avatar"
                />
              </div>
            </label>
            <ul
              tabIndex={0}
              className="mt-3 z-[1] p-2 shadow menu menu-sm dropdown-content bg-base-100 rounded-box w-52"
            >
              <li>
                <a href="#">{t("header.profile")}</a>
              </li>
              <li>
                <a href="#">{t("header.settings")}</a>
              </li>
              <li>
                <button
                  onClick={handleLogout}
                  className="text-error cursor-pointer"
                >
                  {t("header.logout")}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
